import { combineReducers } from "redux";
import reducer from "../../Redux/Reducer/reducer";
export const rootReducer = combineReducers({
  reducer,
});
